const getList = {};

const getArrayForm = {
  selectFormulaTaskPage: "/nhf-app/formulaspeedtask/selectFormulaSpeedTaskPage",
  formulataskDetail: "/nhf-app/formulaspeedtask/detail",
  checkProductionForecast: "/nhf-app/formulaspeedtask/checkProductionForecast",
  getUnsolvableSpeedFormulaTaskFormula: "/nhf-app/formulaspeedtaskformula/getUnsolvableSpeedFormulaTaskFormula",
  formulataskCacheInit: "/nhf-app/formulaspeedtask/formulataskCacheInit",
  // selectFormulaTaskRawState: "/nhf-app/formulataskraw/selectFormulaTaskRawState",//查询全集原料状态
  selectFormulaTaskFormulaPage: "/nhf-app/formulaspeedtaskformula/selectSpeedFormulaTaskFormulaPage", // 任务配方分页
  taskFormulaPage: "/nhf-app/formulaspeedtaskformula/taskSpeedFormulaPage", // 任务添加配方分页查询
  selectTaskRawFormulaByRawId: "/nhf-app/formulataskformularaw/selectSpeedTaskRawFormulaByRawId",
  selectTaskFormulaRawByTaskFormulaId: "/nhf-app/formulataskformularaw/selectTaskFormulaRawCacheByTaskFormulaId",
  selectTaskFormulaSelfRawByTaskFormulaId: "/nhf-app/formulataskformularaw/selectTaskFormulaSelfRawCacheByTaskFormulaId",
  selectTaskFormulaSelfRawRatioByTaskFormulaId: "/nhf-app/formulataskformularaw/selectTaskFormulaSelfRawRatioByTaskFormulaId",
  myFormulaNhfPage: "/nhf-app/formulaManage/myFormulaNhfPage", // 配方信息分页查询
  selectFormulaTaskRawAllPage: "/nhf-app/formulaspeedtaskraw/selectSpeedFormulaTaskRawAllPage", //全集原料数据
  selectTaskFormulaNutritionByTaskFormulaId: "/nhf-app/formulataskformulanutrition/selectTaskFormulaNutritionCacheByTaskFormulaId",
  selectTaskFormulaNutritionMixByTaskFormulaId: "/nhf-app/formulataskformulanutrition/selectTaskFormulaNutritionMixCacheByTaskFormulaId",
  myRawpage: "/nhf-app/factorystaffraw/myRawpage",
  selectAddFormulaTaskNutritionByCond: "/nhf-app/formulataskformulanutrition/selectAddFormulaTaskNutritionByCond",
  selectReplaceTaskFormulaRaw: "/nhf-app/formulaspeedtaskraw/selectReplaceSpeedTaskFormulaRaw",
  selectTaskFormulaRawAssessPage: "/nhf-app/formulataskformularaw/selectTaskFormulaRawAssessPage",
  exportTaskFormulaRawAssessPage: "/nhf-app/formulataskformularaw/exportTaskFormulaRawAssessPage",
  taskLinearOptimizationByOptimization: "/nhf-app/formulaRemoteCal/taskLinearOptimizationByOptimization",
  selectFormulaTaskFormulaHaveSolutionPage:'/nhf-app/formulataskformula/selectFormulaTaskFormulaHaveSolutionPage',
  asyncTaskLinearOptimizationByOptimization: '/nhf-app/formulaRemoteCal/asyncSpeedCacheTaskLinearByOptimization',

  selectSpeedFormulaTaskFormulaHaveSolutionPage: '/nhf-app/formulaspeedtaskformula/selectSpeedFormulaTaskFormulaHaveSolutionPage',
};

const postArray = {
  saveFormulaTask: "/nhf-app/formulatask/saveFormulaTask",
  formulataskUpdate: "/nhf-app/formulatask/update",
  getSMultiSpeedFormulaTaskLadderFromRedis:"/nhf-app/formulaRemoteCallback/getSMultiSpeedFormulaTaskLadderFromRedis",
  formulataskformularawUpdate: "/nhf-app/formulataskformularaw/updateTaskFormulaRawCacheById",
  formulataskformularawSelfUpdate: "/nhf-app/formulataskformularaw/updateTaskFormulaSelfRawCacheById",
  formulataskformularawSupplementUpdate: "/nhf-app/formulataskformularaw/updateTaskFormulaSupplementRawCacheById",
  formulataskformulanutritionUpdate: "/nhf-app/formulataskformulanutrition/updateFormulaNutritionCacheById",
  formulataskformulanutritionMixUpdate: "/nhf-app/formulataskformulanutrition/updateFormulaMixNutritionCacheById",
  updateFormulaTaskFormula: "/nhf-app/formulaspeedtaskformula/updateSpeedFormulaTaskFormula",
  updateSingleFormulaTaskRaw: "/nhf-app/formulaspeedtaskraw/updateSingleSpeedFormulaTaskRaw",
  batchUpdateFormulaRawLimitCond: "/nhf-app/formulaspeedtaskraw/batchUpdateSpeedFormulaRawLimitCond",
  batchUpdateFormulaNutritionLimitCond: "/nhf-app/formulataskformulanutrition/batchUpdateFormulaNutritionCacheLimitCond",
  // updateFactoryStaffRawPrice:"/nhf-app/factorystaffraw/updateFactoryStaffRawPrice",
  updateFactoryStaffRawPrice:"/nhf-app/formulaspeedtaskraw/updateSingleSpeedFormulaTaskRawPrice",
  ladderAnalysisFormulaTask: "/nhf-app/formulaRemoteCal/asyncTaskLadderBySpeedOptimization",
  asyncReCalTaskLadderBySpeedOptimization: "/nhf-app/formulaRemoteCal/asyncReCalTaskLadderBySpeedOptimization",
  updateOrgFormulaByIds:'/nhf-app/formulatask/updateOrgFormulaByIds',
  batchUpdateFormulaTaskRawPrice: '/nhf-app/formulaspeedtaskraw/batchUpdateSpeedFormulaTaskRawPrice',
  batchAddFormulaRawVal: "/nhf-app/formulaspeedtaskraw/batchAddSpeedFormulaRawConfirm",

  updateSpeedOrgFormulaByIds: '/nhf-app/formulaspeedtask/updateSpeedOrgFormulaByIds',
};

const postFormArray = {
  deleteFormulaTaskLogic: "/nhf-app/formulaspeedtask/deleteFormulaSpeedTaskLogic",
  createFormulaProductByIds: '/nhf-app/formulatask/createFormulaProductByIds',
  sycFormulaToTask:'/nhf-app/formulaspeedtaskformula/sycFormulaToSpeedTask',
  syncLatestEstimatedProduction:'/nhf-app/formulaspeedtaskformula/syncLatestEstimatedProduction',
  syncTaskLatestEstimated:'/nhf-app/formulaspeedtaskformula/syncTaskLatestEstimated',
  addTaskFormulaByIds: "/nhf-app/formulaspeedtaskformula/addSpeedTaskFormulaByIds", // 新增任务配方
  deleteFormulaTaskFormulaRelLogic: "/nhf-app/formulaspeedtaskformula/deleteSpeedFormulaTaskFormulaRelLogic", // 逻辑删除任务配方
  oneClickImport: "/nhf-app/formulaspeedtaskformula/oneClickImport", // 一键导入
  batchAddFormulaRaw: "/nhf-app/formulataskraw/batchAddFormulaRaw",
  batchDelFormulaRaw: "/nhf-app/formulaspeedtaskraw/batchDelSpeedFormulaRaw",
  batchAddFormulaRawUpdateConfirm: "/nhf-app/formulaspeedtaskraw/batchAddSpeedFormulaRawUpdateConfirm",
  batchAddFormulaNutritionUpdateConfirm: "/nhf-app/formulataskformulanutrition/batchAddFormulaNutritionCacheUpdateConfirm",
  createFormulaProduct: "/nhf-app/formulatask/createFormulaProduct",
  updateOrgFormula: "/nhf-app/formulatask/updateOrgFormula",
  deleteFormulaTaskRawById: "/nhf-app/formulataskraw/deleteFormulaTaskRawById",
  batchReplaceRaw: '/nhf-app/formulataskraw/batchReplaceFormulaRawAndTaskRaw',

  createSpeedFormulaProductByIds: '/nhf-app/formulaspeedtask/createSpeedFormulaProductByIds',
};

const baseApi = (arr, method) => {
  let list = {};
  for (let i in arr) {
    list[i] = async (data) => method(arr[i], data);
  }
  return list;
};
import { get, getForm, post, postForm } from "../../Utils/axios";
import { mapState, mapMutations, mapGetters } from "vuex";

export const formulaMixins = {
  data() {
    return {
      raw: [],
      model: {
        records: [],
      },
      // visible: false,
      list: {
        records: [],
      },
      price: ["合同价格", "预测价格", "库存价格", "市场价格"],
      rawTypes: ["所有原料", "组分原料", "拒绝原料"],
      priceOption: [
        { label: "合同价格", value: "1" },
        { label: "预测价格", value: "2" },
        { label: "库存价格", value: "3" },
        { label: "市场价格", value: "4" },
      ],
      modelDetail: {},
      nutrition: [],
      modelLoading: false,
      updateLoading: false,
      selectedRowKeys: [],
      selectedRows: [],
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "50", "60", "100"],
        showSizeChanger: true,
        pageSize: 20,
        total: 0,
        current: 1,
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      factoryId: null,
      bodyStyle: {
        padding: "0 15px 15px",
      },
      modalBodyStyle: { padding: "10px" },
      currentPage: {
        current: 1,
        size: 20,
      },
      modalVisible: false,
      taskId: null,
      analyseVisible: false,
      isFullScreen: false,
      reportTypes: ['配方差异对比报表', '配方成本对比报表', '配方产品对比报表', '原料重量对比报表', '原料评估报表', '全集原料对比报表'],
      // reportTypes: ['配方差异对比报表', '全集原料对比报表'],
    };
  },
  mounted() {
    this.taskId = this.$route.query ? this.$route.query.id || null : null;
    this.factoryId = window.localStorage.getItem("factoryId") || null;
    this.staffId = window.localStorage.getItem("staffId") || null;
    document.addEventListener('fullscreenchange',this.logFullScreen)
  },
  computed: {
    ...mapState("formula", [
      "visible",
      "detail",
      "detail",
      "height",
      "layout",
      "formula",
      "taskRaw",
      "formulaSelectedRows",
      "formulaSelectedRowKeys",
      "resRaw",
      "resNut",
      "forumlaColumns",
      "formulaNutritionColumns",
      "formulaRawColumns",
      "taskRawColumns",
      'rawRows',
      'rawSelect',
      'reportKey',
      'reportVisible',
      'progressVisible',
      'progressPercent',
      'progressModalTitle',
      'progressModalBtnText',
      'progressModalContent',
      'progressType',
      'progressModalUrl',
    ]),
    ...mapGetters("formula", ["isNoneLiner"]),
  },
  methods: {
    ...mapMutations("formula", ["setState", "toggleVisible"]),
    ...baseApi(getList, get),
    ...baseApi(getArrayForm, getForm),
    ...baseApi(postArray, post),
    ...baseApi(postFormArray, postForm),

    diffColor(val) {
      return {
        color: val > 0 ? "red" : val < 0 ? "green" : "",
      };
    },
    diffIconType(val) {
      let type = "";
      if (val > 0) type = "arrow-up";
      if (val < 0) type = "arrow-down";
      return type;
    },

    toggleModalVisible() {
      this.modalVisible = !this.modalVisible;
    },

    // normal page
    pageSetting() {
      return {
        size: 20,
        current: 1,
      };
    },

    async fetchGet({ actions, name, data = {}, isList, loading }) {
      if (actions) {
        try {
          if (loading) this[loading] = true;
          let params = isList ? { ...this.pageSetting(), ...data } : data;
          const res = await actions(params);
          if (name) this[name] = res.data;
          if (isList) this.setPager(res.data);
          if (!res.success && name) this.$message.warn(res.msg);
          return res;
        } catch (error) {
          error.msg && this.$message.warn(error.msg);
        } finally {
          if (loading) this[loading] = false;
        }
      }
    },

    async fetchPost({ actions, data, loading, name, showMessage = true }) {
      try {
        if (loading) this[loading] = true;
        const res = await actions(data);
        showMessage && res.msg !== "" && this.$message.success(res.msg);
        if (name) this[name] = res.data;
        return res.data;
      } catch (error) {
        error.msg && this.$message.warn(error.msg);
      } finally {
        if (loading) this[loading] = false;
      }
    },

    // 设置分页
    setPager(res) {
      const { total, current, size: pageSize } = res;
      this.pagination = {
        ...this.pagination,
        pageSizeOptions: ["10", "20", "30", "40", "50", "60", "100"],
        showSizeChanger: true,
        pageSize,
        total,
        current,
        showTotal: (total) => <div style="flex:1">共{total}条记录</div>,
      };
    },

    cleanSelect() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    getCheckboxProps(record){
      return ({
        props: {
          disabled: this.selectedRowKeys.length >= 20 && !this.selectedRowKeys.includes(record.id)
        },
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      // selectedRowKeys = selectedRowKeys.splice(0,20)
      this.selectedRowKeys = selectedRowKeys
      let arr = [...this.selectedRows, ...selectedRows]
      this.selectedRows = selectedRowKeys.map((i) => {
        return arr.filter((item) => item.id === i || item.rawId === i)[0]
      })
      if(this.list && this.list.records) this.list.records = [...this.list.records]
    },

    tablePageChange(page, filters, sorter) {
      console.log(filters, sorter);
      const { current = 1, pageSize: size } = page;
      this.currentPage = {
        size,
        current,
      };
      return {
        size,
        current,
      };
    },

    fixedNumber(num, len) {
      return num ? Math.round((num + Number.EPSILON) * len) / len : undefined;
    },

    // 乘法
    mul(...val) {
      const strVal = val[0].toString();
      const strValTwo = val[1].toString();
      const index = strVal.indexOf(".");
      const indexTwo = strValTwo.indexOf(".");
      const num = [0, 0];
      if (index > -1) {
        num[0] = strVal.length - 1 - index;
      }
      if (indexTwo > -1) {
        num[1] = strValTwo.length - 1 - index;
      }
      return (
        Math.round(
          val[0] * Math.pow(10, num[0]) * (val[1] * Math.pow(10, num[1]))
        ) / Math.pow(10, num[0] + num[1])
      );
    },

    // 加法
    add(...val) {
      let max = 0;
      let count = 0;
      for (let i = 0; i < val.length; i++) {
        const strVal = val[i].toString();
        const index = strVal.indexOf(".");
        let num = 0;
        if (index > -1) {
          num = strVal.length - 1 - index;
          max = num > max ? num : max;
        }
      }
      for (let i = 0; i < val.length; i++) {
        count += Math.round(val[i] * Math.pow(10, max));
      }
      return count / Math.pow(10, max);
    },

    //减法
    sub(arg1, arg2) {
      let r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      n = r1 >= r2 ? r1 : r2;
      return +((arg1 * m - arg2 * m) / m).toFixed(n);
    },

    // 除
    div(val, valTwo = 100) {
      const strVal = val.toString();
      const strValTwo = valTwo.toString();
      const index = strVal.indexOf(".");
      const indexTwo = strValTwo.indexOf(".");
      const num = [0, 0];
      if (index > -1) {
        num[0] = strVal.length - 1 - index;
      }
      if (indexTwo > -1) {
        num[1] = strValTwo.length - 1 - index;
      }
      return (
        Math.round(val * Math.pow(10, num[0])) /
        (Math.round(valTwo * Math.pow(10, num[1])) *
          Math.pow(10, num[0] - num[1]))
      );
    },
    logFullScreen(){
      if(window.document.fullscreenElement){
        this.isFullScreen = true
      }else{
        this.isFullScreen = false
      }
    },
    full(){
      let fullScreen = window.document.documentElement
      if(!this.isFullScreen){
        if(fullScreen.requestFullscreen){
          fullScreen.requestFullscreen()
        }else if(fullScreen.msRequesFullscreen){
          fullScreen.msRequesFullscreen()
        }else if(fullScreen.mozRequesFllscreen){
          fullScreen.mozRequesFllscreen()
        }else if(fullScreen.webkitRequesFullscreen){
          fullScreen.webkitRequesFullscreen()
        }
      }else{
        if(window.document.exitFullscreen){
          window.document.exitFullscreen()
        }else if(window.document.webkitCancelFullscreen){
          window.document.webkitCancelFullscreen()
        }else if(window.document.mozCancelFullscreen){
          window.document.mozCancelFullscreen()
        }else if(window.document.msExitFullscreen){
          window.document.msExitFullscreen()
        }
      }
      // this.isFullScreen = !this.isFullScreen
    },
  },
};
